module.exports = __webpack_public_path__ + "media/images/gallery-image7-7fc838c49f1d957c704913897154b49a.webp";